import { useEffect, useState } from 'react';
import { getCompanyById, updateCompany } from '../../services/company/editCompanyService.js';
import { isNameValid, isShortnameValid, isDescriptionValid } from '../../utils/validations/companyValidations.js';

const initialForm = {
    name: '',
    shortname: '',
    description: ''
};

export const useEditCompany = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadCompany = async () => {
            try {
                const company = await getCompanyById(id);
                setForm({ ...initialForm, ...company });
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Empresa no encontrada.'
                        : 'Error al obtener los datos de la empresa.'
                );
            }
        };

        loadCompany();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        if (!isNameValid(form.name)){
            setError('El nombre de la empresa solo pueden contener letras.');
            return;
        }
        if (!isShortnameValid(form.shortname)){
            setError('El nombre corto solo pueden contener letras y números.');
            return;
        }
        if (!isDescriptionValid(form.description)){
            setError('El campo comentarios no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await updateCompany(id, {
                ...form
            });
            setSuccess('La empresa ha sido actualizada exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar la empresa'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}